module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"profileComplited":"Профиль заполнен на {percent}%","left":"Осталось заполнить","viewProfile":"Смотреть профиль компании"}}')
  delete Component.options._Ctor
}
